import { useAppSelector } from 'store/hooks';
import { useMatches } from 'react-router-dom';
import { RouteItemType } from 'routes/index';
import { skipToken, useQuery } from '@tanstack/react-query';
import { ElementViewerDataResponse } from 'components/element-viewer';

interface RouteParams {
    elementId?: string;
}

export function useConciergeVisible(): boolean {
    const showOn = useAppSelector((state) => state.auth?.conciergeInfo?.showOn);
    const enabled = useAppSelector((state) => state.auth?.conciergeInfo?.enabled);
    const isAdmin = useAppSelector((state) => state.auth?.userInfo?.isAdmin);
    const isPowerUser = useAppSelector((state) => state.auth?.userInfo?.isPowerUser);
    const matches = useMatches();

    const lastMatch = matches[matches.length - 1];
    const handle = lastMatch?.handle as RouteItemType;
    const params = lastMatch?.params as RouteParams;

    const elementId = Number(params?.elementId) || 0;

    const { data: viewerCacheData } = useQuery<ElementViewerDataResponse>({
        queryKey: [`elementViewer_${elementId}`],
        queryFn: skipToken,
        staleTime: Infinity,
    });

    if (!enabled) return false;

    if (isAdmin || isPowerUser) return true;

    if (!showOn) return false;

    if (handle?.isElementViewer) {
        if (!showOn.element) return false;
        if (showOn.elementScope === 'selected') {
            if (!viewerCacheData) return false;
            return viewerCacheData.elementData.row.conciergeIconVisibility !== 'hidden';
        }
        const vis = viewerCacheData?.elementData?.row?.conciergeIconVisibility;
        return vis !== 'hidden';
    }

    if (handle?.routeUid === 'home-page' || handle?.routeUid === 'home-catalog') {
        return showOn.catalog;
    }

    return false;
}
